import { motion } from "framer-motion";
import { fadeInOut } from "@/utils/fadeInOut.js";
import type { MutableRefObject, ReactNode } from "react";
import React from "react";
import { cn } from "@rosette/ts/src/util/cn.js";


export interface MenuContainerProps {
    contentRef: MutableRefObject<HTMLDivElement | null>;
    closeMenu: () => void;
    isMobile: boolean;
    children?: ReactNode;
}


export function MenuContainer({
    contentRef, closeMenu, isMobile, children,
}: MenuContainerProps) {
    return (
        <motion.div
            className={cn(
                "absolute inset-0 w-full h-full z-99 overflow-y-auto overflow-x-hidden pointer-events-auto",
                isMobile ? "pb-[4.5em] text-xl" : null,
            )}
            onClick={(event) => {
                const menuContent = contentRef.current;
                if (!menuContent)
                    return;

                const x = event.clientX;
                const y = event.clientY;
                const bounds = menuContent.getBoundingClientRect();
                if (x >= bounds.left && x <= bounds.right && y >= bounds.top && y <= bounds.bottom)
                    return;

                closeMenu();
            }}
            {...fadeInOut(0.2)}>

            <div className={cn(
                "flex flex-col items-center mx-auto p-3 min-h-full",
                isMobile ? "justify-end" : "justify-center",
            )}>
                {children}
            </div>
        </motion.div>
    );
}
